export default function CheckIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="#fff" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-8 h-8 relative -top-7 -left-6 -mb-8 -mr-3">
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  )
}

